import script from "./NewDetail.vue?vue&type=script&setup=true&name=System_platform&lang=js"
export * from "./NewDetail.vue?vue&type=script&setup=true&name=System_platform&lang=js"

import "./NewDetail.vue?vue&type=style&index=0&id=2a33655d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a33655d"]])

export default __exports__